import React, { useState } from 'react';
import './OnboardingInputs.css';

const ContactInfoSelector = ({ onContactSelect, selectedContactInfo, languageSetting }) => {
  const contactOptions = {
    FIRST_NAME: { name: languageSetting === "ENGLISH" ? 'First Name' : 'Nombre', prompt: languageSetting === "ENGLISH" ? 'Enter Your First Name' : 'Ingresa tu nombre' },
    LAST_NAME: { name: languageSetting === "ENGLISH" ? 'Last Name' : 'Apellido', prompt: languageSetting === "ENGLISH" ? 'Enter Your Last Name' : 'Ingresa tu apellido' },
    EMAIL: { name: languageSetting === "ENGLISH" ? 'Email' : 'Correo Electrónico', prompt: languageSetting === "ENGLISH" ? 'Enter Your Email Address' : 'Ingresa tu correo electrónico' },
    PHONE: { name: languageSetting === "ENGLISH" ? 'Phone Number' : 'Número De Teléfono', prompt: languageSetting === "ENGLISH" ? 'Enter Your Phone Number' : 'Ingresa tu número de teléfono' },
    ADDRESS: { name: languageSetting === "ENGLISH" ? 'Address' : 'Dirección', prompt: languageSetting === "ENGLISH" ? 'Enter Your Address' : 'Ingresa tu dirección' },
    // Add more contact options as needed
  };


  const newContactInfo = Object.keys(contactOptions).map((x) => ({ name: contactOptions[x].name, id: x, showInput: selectedContactInfo[x] ? selectedContactInfo[x].showInput : false, value: selectedContactInfo[x] ? selectedContactInfo[x].value : '', prompt: contactOptions[x].prompt }))

  const handleDivClick = (option) => {
    // Clear the value if the input is being hidden
    if(newContactInfo[option].showInput) {
      newContactInfo[option].value = '';
    }
    newContactInfo[option].showInput = !newContactInfo[option].showInput;
    onContactSelect(newContactInfo[option]);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    const newContactInfo = selectedContactInfo[event.target.dataset.contactName]
    newContactInfo['value'] = value;
    onContactSelect(newContactInfo);
  };

  return (
    <div className="container">
      {Object.keys(newContactInfo).map((option) => (
        <div key={option} className="option-container">
          <div
            onClick={() => handleDivClick(option)}
            className="option-button"
          >
            {newContactInfo[option].name} {newContactInfo[option].showInput}
          </div>
          {newContactInfo[option].showInput && (
            <div className="input-container">
              <p className="help-text">{newContactInfo[option].prompt}</p>
              <input
                type="text"
                value={newContactInfo[option].value}
                onChange={(event) => handleInputChange(event)}
                className="input-field"
                data-contact-name={newContactInfo[option].id}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ContactInfoSelector;
